import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CrmWorkspacesStore } from '@pinnakl/crm/data-access';
import { catchError, NEVER, throwError } from 'rxjs';
import { outlookAuthInterceptor, OutlookSessionExpiredError } from './outlook-auth-interceptor';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const workspaces = inject(CrmWorkspacesStore);
  return outlookAuthInterceptor(req, next).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof OutlookSessionExpiredError)) return throwError(() => error);
      workspaces.reset();
      return NEVER;
    }),
  );
};
